import React, { useEffect, useState } from 'react';
import "./ServicesSettingsAdd.scss";

import { useDispatch, useSelector } from 'react-redux';
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { setServicesAction } from '../../../store/servicesReducer';
import { setCurrentUserAction } from '../../../store/currentUserReducer';
import ServicesSettingsItemDetail from '../ServicesSettingsItemDetail/ServicesSettingsItemDetail';

const ServicesSettingsAdd = () => {
  const dispatch = useDispatch();
  const settings = useSelector(state => state.settings.settings)
  const services = useSelector(state => state.services.services)
  const clinic = useSelector(state => state.recordsTable.clinic)
  const currentUser = useSelector(state => state.currentUser.currentUser)
  const [user, setUser] = useState(null);
  const [sevicesList, setSevicesList] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!services || services.length === 0) {
      fetchServices();
    }
  }, [services])
  useEffect(() => {
    if (!currentUser) {
      fetchUserInfo();
    }
    setUser(currentUser);
  }, [currentUser])

  const [fetchUserInfo] = useFetching(async () => {
    const response = await PostService.getUserInfo()
    if (response.data.success && response.data.result !== false) {
      dispatch(setCurrentUserAction(response.data.result))
    }
  })

  const [fetchServices] = useFetching(async () => {
    const response = await PostService.getServices()
    if (response.data.success && response.data.result !== false) {
      dispatch(setServicesAction(response.data.result))
    }
  })
  
  // Функция для проверки наличия группы администратора
  const isAdmin = (user) => {
    return user && Array.isArray(user.groups) && user.groups.includes('1');
  };

  return (
    <>
      {/* Отображаем кнопку только для администраторов */}
      {isAdmin(user) &&
        <div className='services-settings-list-add' onClick={() => setOpen(true)}>добавить настройку</div>
      }
      
      <div className="services-settings-list-add__detail">
        <ServicesSettingsItemDetail element={null} closeHandler={() => setOpen(false)} isOpen={open} />
      </div>
    </>
  );
};

export default ServicesSettingsAdd;